import React from 'react'
import { Projects} from '../../constants';
import ProjectCard from '../common/ProjectCard';
import SectionTitle from '../common/SectionTitle';
const Work = (props) => {
  const { linkArr } = props
  return (
    <div ref={linkArr[0].ref} className='Work'>
      <SectionTitle
        to='Work'
      />
      {Projects.map((item, idx) =>
        <div key={`ProjectCard-${idx}`} className='card-container'>
          <ProjectCard
            idx={idx}
            {...item}
          />
          <div className='bottom-line' ></div>
        </div>
      )}
    </div>
  )
}

export default Work
